import {setupServiceWorker} from "@/pwa/registerSW.ts";
import {useEffect, useRef} from "react";

function useUpdateSW() {
    const updateSWRef = useRef<((reload?: boolean) => Promise<void>) | null>(null)

    useEffect(() => {
        updateSWRef.current = setupServiceWorker(() => {
            if (updateSWRef.current) {
                updateSWRef.current(true)
            }
        });
    }, [])
}

export {useUpdateSW}
